export type AggregatorSearchComponentValue = {
  abn: string,
  salesforceId: string,
  entityName: string,
  Type?: 'broker' | 'vendor' | 'dealer' | 'aggregator',
} | null;
